import React from 'react'
import Cropper from 'react-easy-crop'
import './Cropper.css'

export default class cropper extends React.Component {
  state = {
    parentModule: null,
    imageSrc: null,
    crop: { x: 0, y: 0 },
    zoom: 1
  }

  constructor(props) {
    super();
    this.state.parentModule = props.module;
    this.state.imageSrc = props.image;
    if (props.cropAreaPixels.width == 0 && props.cropAreaPixels.height == 0 && props.cropAreaPixels.x == 0 && props.cropAreaPixels.y == 0) {
      let img = new Image();
      img.src = props.image;
      props.cropAreaPixels.width = img.width;
      props.cropAreaPixels.height = img.height;
    }
    this.state.initialCroppedAreaPixels = props.cropAreaPixels; //Automatically sets the crop and zoom.
    this.state.cropSize = { width: props.module.state.width, height: props.module.state.height };
    Object.freeze(this.state);

    props.module.updateCropperGrid = (width, height) => {
      this.setState({ cropSize: { width: width, height: height } });
    }
  }

  onCropChange = (crop) => {
    this.setState({ crop })
  }

  onZoomChange = (zoom) => {
    this.setState({ zoom })
  }

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ areaPixels: croppedAreaPixels });
  }

  render() {
    return (
      <div className="cropper">
        <div className="crop-container">
          <Cropper
            image={this.state.imageSrc}
            cropSize={this.state.cropSize}
            crop={this.state.crop}
            zoom={this.state.zoom}
            maxZoom={10}
            initialCroppedAreaPixels={this.state.initialCroppedAreaPixels}
            onCropChange={this.onCropChange}
            onZoomChange={this.onZoomChange}
            onCropComplete={this.onCropComplete}
          />
          <div className="controls">
            <button onClick={() => this.state.parentModule.endImageEditMode(this.state.areaPixels)}>Done</button>
          </div>
        </div>
      </div>
    )
  }
}


//Functions to apply cropping data to image for displaying it:
const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', (error) => reject(error))
    image.src = url
  })

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 */
export async function getCroppedImg(imageSrc, pixelCrop, canvas, ctx) {
  const image = await createImage(imageSrc);
  //If the crop parameters are the entire image, just return the original URL. This also preserves GIFs.
  if (pixelCrop.width == 0 && pixelCrop.height == 0 && pixelCrop.x == 0 && pixelCrop.y == 0) {
    return imageSrc;
  }

  if (!(canvas && ctx)) {
    throw new Error("Error getting drawing canvas/context.")
    return null
  }

  //Accounting for missing crop information
  if (!pixelCrop.width) { pixelCrop.width = image.width; }
  if (!pixelCrop.height) { pixelCrop.height = image.height; }
  if (!pixelCrop.x) { pixelCrop.x = 0; }
  if (!pixelCrop.y) { pixelCrop.y = 0; }

  // set canvas size to match the bounding box
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // Draw the cropped image onto the new canvas
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  )

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file))
    }, 'image/png')
  })
}
